import moment from "moment";

const INPUT_FORMAT = "YYYY-MM-DD HH:mm";

export const format12Hour = (time: string) => {
  const currentTime = moment().format("YYYY-MM-DD");
  const currentDateTime = `${currentTime} ${fixLegacyTimeFormat(time)}`;
  if (currentDateTime.toLowerCase().includes("invalid")) {
    return "00:00";
  }
  const value = moment(currentDateTime, INPUT_FORMAT);
  return value.isValid() ? value.format("hh:mma") : "00:00";
};

function fixLegacyTimeFormat(time: string) {
  if (is24HourFormat(time)) return time;
  return convertTo24HourFormat(time);
}

function is24HourFormat(time: string) {
  const regex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
  return regex.test(time);
}

function convertTo24HourFormat(timeValue: string) {
  const time = timeValue.replace(".", ":");
  const parts = time.match(/^(\d{1,2}):(\d{2})\s?(am|pm)?$/i);
  if (!parts) {
    return "Invalid Time Format";
  }

  let hours = parseInt(parts[1], 10);
  const minutes = parseInt(parts[2], 10);
  const ampm = parts[3] ? parts[3].toLowerCase() : null;

  if (ampm === "pm" && hours < 12) {
    hours += 12;
  } else if (ampm === "am" && hours === 12) {
    hours = 0;
  }

  const formattedTime = `${hours < 10 ? "0" : ""}${hours}:${
    minutes < 10 ? "0" : ""
  }${minutes}`;
  return formattedTime;
}

export function isClosed(openingHours: string) {
  if (openingHours) {
    if (openingHours.toLowerCase().includes("closed")) {
      return true;
    } else if (format12Hour(openingHours) === "00:00") {
      return true;
    }
    return false;
  }
  return true;
}
